const IN_APP_AUTH_ENTITLED_PLANS = new Set([
  'AppSumo (Tier 4)',
  'AppSumo (Tier 5)',
  'AppSumo (Tier 6)',
  'AppSumo (Tier 7)',
  'AppSumo (Tier 8)',
  'AppSumo (Tier 9)',
  'Elite',
  'Scale',
  'Enterprise',
])

const hasInAppAuthAccess = userControl =>
  IN_APP_AUTH_ENTITLED_PLANS.has(userControl)

export { IN_APP_AUTH_ENTITLED_PLANS, hasInAppAuthAccess }
